var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.layerShow,
          expression: "layerShow",
        },
      ],
      staticClass: "select-layer",
      attrs: { id: "select-layer-box" },
      on: {
        click: function ($event) {
          return _vm.hiddenLayer($event)
        },
      },
    },
    [
      _vm.listData.length > 1
        ? _c(
            "ul",
            { staticClass: "dt-source-unfold" },
            [
              _c("li", [
                _c("h4", { staticClass: "dt-source-unfold-title" }, [
                  _vm._v("\n        " + _vm._s(_vm.selectTitle) + "\n      "),
                ]),
              ]),
              _vm._v(" "),
              _vm._l(_vm.listData, function (item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    class:
                      _vm.getName(item) === _vm.getName(_vm.curData)
                        ? "source-cur"
                        : "",
                    on: {
                      click: function ($event) {
                        return _vm.changeOption(item, index, $event)
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "dt-source-item",
                        attrs: {
                          href: "javascript:void(0);",
                          uigs: "btn_source",
                        },
                      },
                      [
                        _c("SiteIcon", {
                          attrs: { "icon-img": _vm.getIcon(item) },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.getName(item)))]),
                      ],
                      1
                    ),
                  ]
                )
              }),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }